import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea';

import { useAuth } from 'src/contexts/auth';
import { useData } from 'src/contexts/data';
import { ModelOfUnityContract } from 'src/database';
import { useFormCreateBidding } from 'src/controllers/Bidding/CreateBiddingController';
import { useListModalitiesController } from 'src/controllers/Modalities/ListModalitiesController';
import { useFormCreateUnityContract } from 'src/controllers/UnityContracts/CreateUnityContractController';

import LoadingScreen from 'src/components/LoadingScreen';
import { SyncLoader } from 'react-spinners';
import { useListUnityContractsController } from 'src/controllers/UnityContracts/ListUnityContractsController';
import { useListUnitysController } from 'src/controllers/Unitys/ListUnitysController';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';

interface filteredProps {
	label?: string;
	value?: string;
}

interface selectedUnityProps {
	ID?: string;
	NOME_ORGAOUNIDADE?: string;
	ORGAOUNIDADE?: string;
	TOTALCONTRATADO?: number;
}

const selectedUnityEmptyObj = {
	ID: '',
	NOME_ORGAOUNIDADE: '',
	ORGAOUNIDADE: '',
	TOTALCONTRATADO: 0,
};

let BiddingForm: React.FC;

BiddingForm = () => {
	const { userAgencyName } = useAuth();
	const { currentBidding, budgetUnits, loadingUnits, handleBudgetUnit, setCurrentBidding, setBudgetUnits } =
		useData();

	const [valueModalities, setValueModalities] = useState('');
	const [filteredModalities, setFilteredModalities] = useState<filteredProps[]>([{ label: '', value: '' }]);

	const [valueUnity, setValueUnity] = useState<selectedUnityProps>(selectedUnityEmptyObj);
	const [selectedUnity, setSelectedUnity] = useState<selectedUnityProps[]>([]);

	const [unitAlreadyExist, setUnitAlreadyExist] = useState(false);

	const { getController } = useFormCreateBidding();
	const { getContractController } = useFormCreateUnityContract();
	const { getModalityListController } = useListModalitiesController();
	const { getListUnityContracts, handleListUnityContractController } = useListUnityContractsController();
	const { getUnityListController } = useListUnitysController();

	const rightFormActive = currentBidding?.ID;
	const history = useHistory();

	useEffect(() => {
		if (currentBidding?.ID) {
			getController.formik.setValues(currentBidding);
			currentBidding.DESCRICAO_MODALIDADE && setValueModalities(currentBidding.DESCRICAO_MODALIDADE);
		}

		if (budgetUnits.length) {
			setSelectedUnity(
				budgetUnits.map((unity) => {
					return {
						ID: unity.ID,
						NOME_ORGAOUNIDADE: unity.NOME_ORGAOUNIDADE,
						ORGAOUNIDADE: unity.ORGAOUNIDADE,
						TOTALCONTRATADO: unity.TOTALCONTRATADO,
					};
				})
			);
		}
	}, [currentBidding, budgetUnits]);

	const modalities = getModalityListController.modalitiesData.map((modality) => {
		return { label: modality.DESCRICAO, value: modality.ID };
	});

	const unitys: selectedUnityProps[] = getUnityListController.AllUnitysData.map((unity) => {
		return { NOME_ORGAOUNIDADE: unity.NOME, ORGAOUNIDADE: unity.ID, TOTALCONTRATADO: 0 };
	});

	const status = [
		{ label: 'Ativo', value: 0 },
		{ label: 'Inativo', value: 1 },
	];

	const searchModalities = (event: any) => {
		let filteredModalities;
		if (!event.query.trim().length) {
			filteredModalities = [...modalities];
		} else {
			filteredModalities = modalities.filter((modalities) => {
				return modalities.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredModalities(filteredModalities);
	};

	const deleteBudgetUnitDialogFooter = (
		<React.Fragment>
			<Button
				label='Não'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleListUnityContractController.closeBudgetUnitRemoveDialog}
			/>
			<Button
				label='Sim'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getListUnityContracts.removableBudgetUnit &&
						handleListUnityContractController.removeBudgetUnit(getListUnityContracts.removableBudgetUnit);
				}}
			/>
		</React.Fragment>
	);

	const actionBodyTemplate = (unity: ModelOfUnityContract) => {
		return (
			<React.Fragment>
				<Button
					icon='pi pi-id-card'
					className='p-button-rounded p-button-text p-button-success p-mr-2'
					onClick={() => {
						handleBudgetUnit(unity);
					}}
				/>
				<Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-text p-button-danger'
					onClick={() => handleListUnityContractController.openBudgetUnitRemoveDialog(unity)}
				/>
			</React.Fragment>
		);
	};

	const handleAddUnity = () => {
		let newUnity = unitys.filter((unidade) => {
			if (valueUnity.ORGAOUNIDADE) return valueUnity.ORGAOUNIDADE.includes(unidade.ORGAOUNIDADE || '');
		});
		setSelectedUnity(selectedUnity.concat(newUnity));
	};

	return (
		<div className='p-grid'>
			{getController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<Toast ref={getController.toast} />
			<Toast ref={getContractController.toast} />
			<Toast ref={getListUnityContracts.toast} />
			<div className='p-col-12 p-md-6'>
				<div className='card p-fluid'>
					<h5>{currentBidding ? 'Edição de Licitação' : 'Cadastro de Licitação'}</h5>
					<div className='p-grid p-fluid'>
						<div className='p-col-12'>
							Orgão: <h5>{userAgencyName}</h5>
						</div>
						<div className='p-field p-col-4'>
							<label htmlFor='stauts'>Status</label>
							<Dropdown
								id='stauts'
								value={getController.formik.values.STATUS}
								onChange={(e) => getController.formik.setFieldValue('STATUS', e.value)}
								optionLabel='label'
								options={status}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getController.formik.touched.STATUS && getController.formik.errors.STATUS,
									'popup-form-inactive': !(
										getController.formik.touched.STATUS && getController.formik.errors.STATUS
									),
								})}>
								{getController.formik.errors.STATUS}
							</div>
						</div>
						<div className='p-field p-col-12'>
							<label htmlFor='objeto'>Objeto</label>
							<InputTextarea
								id='objeto'
								autoResize
								maxLength={1000}
								{...getController.formik.getFieldProps('OBJETO')}
								onChange={getController.formik.handleChange('OBJETO')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getController.formik.touched.OBJETO && getController.formik.errors.OBJETO,
									'popup-form-inactive': !(
										getController.formik.touched.OBJETO && getController.formik.errors.OBJETO
									),
								})}>
								{getController.formik.errors.OBJETO}
							</div>
						</div>
						<div className='p-field p-col-12'>
							<label htmlFor='modalidade'>Modalidade</label>
							<AutoComplete
								id='modalidade'
								value={valueModalities}
								field='label'
								placeholder='Buscar...'
								onChange={(e) => {
									setValueModalities(e.value);
									getController.formik.setFieldValue(
										'MODALIDADE',
										filteredModalities.find((modalities) => {
											return e.value === modalities.label;
										})?.value || ''
									);
								}}
								onSelect={(e) => {
									setValueModalities(e.value.label);
									getController.formik.setFieldValue('MODALIDADE', e.value.value);
								}}
								suggestions={filteredModalities}
								completeMethod={searchModalities}
								dropdown
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getController.formik.touched.MODALIDADE &&
										getController.formik.errors.MODALIDADE,
									'popup-form-inactive': !(
										getController.formik.touched.MODALIDADE &&
										getController.formik.errors.MODALIDADE
									),
								})}>
								{getController.formik.errors.MODALIDADE}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-6'>
							<label htmlFor='numLicitacao'>Número de licitação</label>
							<InputText
								id='numLicitacao'
								type='text'
								maxLength={20}
								{...getController.formik.getFieldProps('NUMEROLICITACAO')}
								onChange={getController.formik.handleChange('NUMEROLICITACAO')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getController.formik.touched.NUMEROLICITACAO &&
										getController.formik.errors.NUMEROLICITACAO,
									'popup-form-inactive': !(
										getController.formik.touched.NUMEROLICITACAO &&
										getController.formik.errors.NUMEROLICITACAO
									),
								})}>
								{getController.formik.errors.NUMEROLICITACAO}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-6'>
							<label htmlFor='numProcessAdm'>Número do Processo ADM</label>
							<InputText
								id='numProcessAdm'
								type='text'
								maxLength={20}
								{...getController.formik.getFieldProps('NUMEROPROCESSOADM')}
								onChange={getController.formik.handleChange('NUMEROPROCESSOADM')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getController.formik.touched.NUMEROPROCESSOADM &&
										getController.formik.errors.NUMEROPROCESSOADM,
									'popup-form-inactive': !(
										getController.formik.touched.NUMEROPROCESSOADM &&
										getController.formik.errors.NUMEROPROCESSOADM
									),
								})}>
								{getController.formik.errors.NUMEROPROCESSOADM}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-6'>
							<label htmlFor='datalicitacao'>Data da Licitação</label>
							<InputMask
								id='datalicitacao'
								mask='99/99/9999'
								placeholder='__/__/____'
								{...getController.formik.getFieldProps('DATALICITACAO')}
								onChange={(e) => getController.formik.setFieldValue('DATALICITACAO', e.value)}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getController.formik.touched.DATALICITACAO &&
										getController.formik.errors.DATALICITACAO,
									'popup-form-inactive': !(
										getController.formik.touched.DATALICITACAO &&
										getController.formik.errors.DATALICITACAO
									),
								})}>
								{getController.formik.errors.DATALICITACAO}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-6'>
							<label htmlFor='valorGlobal'>Valor Global</label>
							<InputNumber
								id='valorGlobal'
								{...getController.formik.getFieldProps('VALORGLOBAL')}
								onChange={(e) => getController.formik.setFieldValue('VALORGLOBAL', e.value)}
								mode='currency'
								currency='BRL'
								locale='pt-BR'
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getController.formik.touched.VALORGLOBAL &&
										getController.formik.errors.VALORGLOBAL,
									'popup-form-inactive': !(
										getController.formik.touched.VALORGLOBAL &&
										getController.formik.errors.VALORGLOBAL
									),
								})}>
								{getController.formik.errors.VALORGLOBAL}
							</div>
						</div>
					</div>

					<div className='p-field p-grid'>
						<div className='p-field p-col-6 '>
							{currentBidding ? (
								<Button
									type='button'
									label='Gravar alterações'
									onClick={() => {
										getController.formik.handleSubmit();
									}}
								/>
							) : (
								<Button
									type='button'
									label='Cadastrar novo'
									onClick={() => {
										getController.formik.handleSubmit();
									}}
								/>
							)}
						</div>
						<div className='p-field p-col-6 '>
							<Button
								onClick={() => {
									history.push('/listBidding');
									sessionStorage.removeItem('@biddingCurrent');
									setCurrentBidding(null);
									sessionStorage.removeItem('@budgetUnits');
									setBudgetUnits([]);
								}}
								label='Voltar para listagem'
								className='p-button p-button-secondary'
							/>
						</div>
					</div>
				</div>
			</div>

			<div
				className={classNames('p-col-12 p-md-6 popup-fade', {
					'popup-form-active': rightFormActive,
					'popup-form-inactive': !rightFormActive,
				})}>
				<div className='card p-fluid'>
					<h5>Unidades orçamentárias</h5>
					<div className='p-field'>
						<label htmlFor='Unity'>Selecione a unidade orçamentária</label>
						<Dropdown
							id='Unity'
							placeholder='Selecionar...'
							value={valueUnity}
							showClear
							resetFilterOnHide
							filter
							emptyFilterMessage='Nenhum resultado encontrado.'
							onChange={(e) => {
								if (!!e.value) {
									if (
										!budgetUnits.find((unit) => {
											return unit.ORGAOUNIDADE === e.value.ORGAOUNIDADE;
										})
									) {
										setUnitAlreadyExist(false);
									} else {
										setUnitAlreadyExist(true);
									}
									getContractController.formikUnityContract.setFieldValue(
										'ORGAOUNIDADE',
										e.value.ORGAOUNIDADE
									);
								}
								setValueUnity(e.value);
							}}
							optionLabel='NOME_ORGAOUNIDADE'
							options={unitys}
							className='multiselect-custom'
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active': unitAlreadyExist,
								'popup-form-inactive': !unitAlreadyExist,
							})}>
							Contrato desta unidade orçamentária já cadastrado!
						</div>
					</div>

					<div className='p-field'>
						<DataTable
							className='p-datatable-sm'
							dataKey='ORGAOUNIDADE'
							value={selectedUnity}
							scrollable
							scrollHeight='412px'>
							<Column field='NOME_ORGAOUNIDADE' header='Unidade Orçamentaria'></Column>
							<Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
						</DataTable>
						{loadingUnits || getContractController.loading || getListUnityContracts.loading ? (
							<div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
								<SyncLoader color='#0388e5' size={8} />
							</div>
						) : (
							<></>
						)}
					</div>

					<div className='p-field p-grid'>
						<div className='p-field p-col-12 '>
							<Button
								label='Adicionar'
								type='button'
								onClick={() => {
									if (
										!budgetUnits.find((unit) => {
											return unit.ORGAOUNIDADE === valueUnity.ORGAOUNIDADE;
										})
									) {
										getContractController.formikUnityContract.handleSubmit();
										handleAddUnity();
									}
								}}
							/>
						</div>
					</div>

					<Dialog
						style={{ width: '450px' }}
						visible={getListUnityContracts.budgetUnitRemoveDialog}
						onHide={handleListUnityContractController.closeBudgetUnitRemoveDialog}
						footer={deleteBudgetUnitDialogFooter}
						header='Remover unidade'
						modal>
						<div className='confirmation-content'>
							<i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
							{getListUnityContracts.removableBudgetUnit && (
								<span>
									Você tem certeza que deseja remover a unidade{' '}
									<b>{getListUnityContracts.removableBudgetUnit.NOME_ORGAOUNIDADE}</b>?
								</span>
							)}
						</div>
					</Dialog>
				</div>
			</div>
		</div>
	);
};

export default BiddingForm;
